(()=>{'use strict';const node=document.getElementById('abn-config');if(!node)return;const c=JSON.parse(node.textContent),$=s=>document.querySelector(s),form=$('#abn-form'),drawer=$('#abn-cart'),esc=s=>String(s??'').replace(/[&<>"']/g,x=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[x]));const protectionId=46987114840111,serviceIds=[46987114840111,46989948977199],coveredHandles=['aera-ergonomic-orthopedic-cushion-pro','aera-ergonomic-seat-cushion'];const isService=i=>serviceIds.includes(i.variant_id);async function syncCoverage(v){const n=v.items.filter(i=>coveredHandles.includes(i.handle)).reduce((a,i)=>a+i.quantity,0),services=v.items.filter(isService);if(!services.length)return v;const primary=services.find(i=>i.variant_id===protectionId),updates={};services.forEach(i=>{const wanted=i===primary?n:0;if(i.quantity!==wanted)updates[i.key]=wanted});if(Object.keys(updates).length)v=await api('cart/update.js',{updates});if(n&&!primary){await api('cart/add.js',{items:[{id:protectionId,quantity:n,properties:{_acp_protection:'true'}}]});v=await api('cart.js')}return v}let busy=false,lastFocus,cart;const money=n=>new Intl.NumberFormat('en',{style:'currency',currency:cart?.currency||'USD'}).format(n/100);async function api(path,data){const res=await fetch((window.Shopify?.routes?.root||'/')+path,{method:data?'POST':'GET',headers:{'Content-Type':'application/json'},...(data?{body:JSON.stringify(data)}:{})});let v;try{v=await res.json()}catch(_){throw Error('Unable to update your bag. Please try again.')}if(!res.ok)throw Error(v.description||v.message||'Please try again.');return v}function selectors(){const host=$('#abn-selectors');host.innerHTML=`<button type="button" class="abn-size-chart-link" data-abn-size-chart><svg width="20" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor"><path d="M1 4h22v10H1zM4 4v4m4-4v6m4-6v4m4-4v6m4-6v4M4 1h16M4 0v3m16-3v3"/></svg>Size Chart</button><div class="abn-source-options"><p class="abn-color-label">Color: <strong data-abn-color-name>${esc(c.options[0].values[0])}</strong></p><div class="abn-color-swatches">${c.options[0].values.map((v,i)=>`<button type="button" data-abn-color="${esc(v)}" aria-label="${esc(v)}" aria-pressed="${i===0}"><img src="${esc(c.colorImages[v])}" width="48" height="48" alt="${esc(v)}"></button>`).join('')}</div><select data-pair="0" data-option="0" class="abn-color-value" aria-label="Color">${c.options[0].values.map(v=>`<option>${esc(v)}</option>`).join('')}</select><label class="abn-source-size">${esc(c.options[1].name)}:<select data-pair="0" data-option="1">${c.options[1].values.map(v=>`<option>${esc(v)}</option>`).join('')}</select></label></div>`;host.addEventListener('click',e=>{const chart=e.target.closest('[data-abn-size-chart]');if(chart){const z=$('#abn-zoom');z.querySelector('img').src=c.images[16];open(z);return}const swatch=e.target.closest('[data-abn-color]');if(!swatch)return;const select=host.querySelector('select[data-option="0"]');select.value=swatch.dataset.abnColor;select.dispatchEvent(new Event('change',{bubbles:true}));host.querySelector('[data-abn-color-name]').textContent=select.value;host.querySelectorAll('[data-abn-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===swatch)))})}function render(v){cart=v;const purchased=v.items.filter(i=>!c.gifts.includes(i.variant_id)&&!isService(i)).reduce((a,i)=>a+i.quantity,0);document.querySelectorAll('[data-abn-count],[data-abn-cart-count]').forEach(e=>e.textContent=purchased);const plural=document.querySelector('[data-abn-item-label]');if(plural)plural.textContent=purchased===1?'item':'items';const label=i=>i.handle===c.handle?'AERA Bronoir Skin Pro':i.handle==='aera-relivex-adaptive-correction-system'?'AERA ReliveX Adaptive Correction System':i.product_title;const terms=i=>i.handle===c.handle?['30-day return terms','/pages/aera-bronoir-returns']:i.handle==='aera-relivex-adaptive-correction-system'?['90-day return terms','/pages/aera-relivex-return-policy']:coveredHandles.includes(i.handle)?[i.handle.includes('pro')?'60-day coverage · Terms':'30-day guarantee · Terms',i.handle.includes('pro')?'/pages/acp-return-policy':i.url]:null;$('#abn-lines').innerHTML=v.items.map(i=>{const policy=terms(i),variant=i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:'';return `<article class="abn-line"><img src="${esc(i.image||i.featured_image?.url||'')}" width="76" height="76" alt="${esc(label(i))}"><div class="abn-line-content"><div class="abn-line-top"><h3>${esc(label(i))}</h3><button type="button" class="abn-remove" aria-label="Remove ${esc(label(i))}" data-abn-remove="${esc(i.parent_relationship?.parent_key||i.properties?._abn_group||i.key)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14M10 11v6m4-6v6"/></svg></button></div>${variant?`<p class="abn-line-variant">${esc(variant)}</p>`:''}<p class="abn-line-unit">${money(i.final_price)} each${isService(i)?' · Optional':''}</p>${i.line_level_discount_allocations?.map(d=>`<small class="abn-line-discount">${esc(d.discount_application.title)}</small>`).join('')||''}<div class="abn-line-bottom">${!isService(i)?`<div class="abn-quantity"><button type="button" aria-label="Decrease quantity of ${esc(label(i))}" data-abn-key="${esc(i.key)}" data-abn-quantity="${Math.max(0,i.quantity-1)}">−</button><span>${i.quantity}</span><button type="button" aria-label="Increase quantity of ${esc(label(i))}" data-abn-key="${esc(i.key)}" data-abn-quantity="${i.quantity+1}">+</button></div>`:`<span>Qty ${i.quantity}</span>`}<div class="abn-line-prices">${i.original_line_price>i.final_line_price?`<s>${money(i.original_line_price)}</s>`:''}<strong>${money(i.final_line_price)}</strong></div></div>${policy?`<a class="abn-line-terms" href="${esc(policy[1])}">${esc(policy[0])}</a>`:''}</div></article>`}).join('')||'<div class="abn-cart-empty"><strong>Your bag is empty</strong><p>Find your next comfortable step.</p></div>';$('#abn-total').textContent=money(v.total_price);$('#abn-checkout-total').textContent=money(v.total_price);const savings=$('#abn-cart-savings');savings.hidden=!(v.total_discount>0);savings.querySelector('strong').textContent='−'+money(v.total_discount||0);const shipping=$('#abn-cart-shipping'),bronoir=v.items.some(i=>i.handle===c.handle),mixed=v.items.some(i=>i.handle!==c.handle&&!c.gifts.includes(i.variant_id)&&!isService(i));shipping.hidden=!bronoir;shipping.textContent=bronoir?(mixed?'Your Bronoir shoes include free tracked shipping. Other products follow their own shipping rates at checkout.':'Your Bronoir shoes include free tracked shipping.') :'';$('#abn-checkout').disabled=!v.item_count}function open(d){if(d.open)return;lastFocus=document.activeElement;d.showModal();document.documentElement.style.overflow='hidden'}function close(d){d.close();document.documentElement.style.overflow='';lastFocus?.focus()}async function run(fn){if(busy)return;busy=true;document.querySelectorAll('#abn-form button,[data-abn-sticky],#abn-cart [data-abn-quantity],#abn-cart [data-abn-remove],#abn-checkout').forEach(b=>b.disabled=true);$('#abn-error')&&($('#abn-error').textContent='');$('#abn-cart-error').textContent='';$('#abn-cart-error').hidden=true;try{await fn();if(cart)render(await syncCoverage(cart))}catch(e){if($('#abn-error'))$('#abn-error').textContent=e.message;$('#abn-cart-error').textContent=e.message;$('#abn-cart-error').hidden=false;try{render(await api('cart.js'))}catch(_){}}finally{busy=false;drawer.removeAttribute('aria-busy');document.querySelectorAll('#abn-form button,[data-abn-sticky],#abn-cart [data-abn-quantity],#abn-cart [data-abn-remove],#abn-checkout').forEach(b=>b.disabled=false);if(cart&&!cart.item_count)$('#abn-checkout').disabled=true}}function purchaseLoading(){open(drawer);drawer.setAttribute('aria-busy','true');$('#abn-lines').innerHTML='<p class="abn-cart-loading" role="status">Adding your selected offer…</p>';$('#abn-total').textContent='Updating…';$('#abn-checkout-total').textContent='Updating…';$('#abn-cart-savings').hidden=true;$('#abn-checkout').disabled=true}form?.addEventListener('submit',e=>{const bundle=form.querySelector('kaching-bundles-block .kaching-bundles__block--loaded');if(form.querySelector('[data-abn-app-block]')&&!bundle)return;e.preventDefault();if(busy)return;purchaseLoading();run(async()=>{if(bundle){const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});let data;try{data=await response.json()}catch(_){throw Error('Unable to update your bag. Please try again.')}if(!response.ok)throw Error(data.description||data.message||'Please try again.')}else{const input=form.elements.id;const variant=Number(input.value),quantity=Math.max(1,Math.min(99,Number(form.elements.quantity.value)||1));await api('cart/add.js',{items:[{id:variant,quantity}]})}render(await api('cart.js'));open(drawer)})});form?.addEventListener('change',e=>{if(!e.target.matches('select[data-option]'))return;const opts=[...form.querySelectorAll('select[data-option]')].map(s=>s.value),v=c.variants.find(v=>v.options.every((x,j)=>x===opts[j]));if(v&&form.elements.id){form.elements.id.value=v.id;form.elements.id.dispatchEvent(new Event('change',{bubbles:false}))}});document.addEventListener('click',e=>{const closeButton=e.target.closest('[data-abn-close]');if(closeButton)return close(closeButton.closest('dialog'));if(e.target.closest('[data-abn-bag]'))return run(async()=>{render(await api('cart.js'));open(drawer)});const quantity=e.target.closest('[data-abn-quantity]');if(quantity)return run(async()=>render(await api('cart/change.js',{id:quantity.dataset.abnKey,quantity:Number(quantity.dataset.abnQuantity)})));const remove=e.target.closest('[data-abn-remove]');if(remove)return run(async()=>{const v=await api('cart.js'),updates={};v.items.filter(i=>(i.parent_relationship?.parent_key||i.properties?._abn_group||i.key)===remove.dataset.abnRemove).forEach(i=>updates[i.key]=0);render(await api('cart/update.js',{updates}))});const image=e.target.closest('[data-abn-image]');if(image){$('#abn-main-image').src=image.dataset.abnImage;document.querySelectorAll('[data-abn-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===image)))}if(e.target.closest('[data-abn-zoom]')){const z=$('#abn-zoom');z.querySelector('img').src=$('#abn-main-image').src;open(z)}if(e.target.closest('#abn-checkout'))run(async()=>{render(await api('cart.js'));if(cart.item_count)location.href=(window.Shopify?.routes?.root||'/')+'checkout'})});document.querySelectorAll('dialog').forEach(d=>d.addEventListener('cancel',e=>{e.preventDefault();close(d)}));if(form){selectors();const button=form.querySelector('button[type="submit"]');button.disabled=false;button.removeAttribute('aria-busy')}const params=new URLSearchParams(location.search);document.querySelectorAll('a[href*="'+c.handle+'"]').forEach(a=>{const u=new URL(a.href);for(const[k,v]of params)if(/^(utm_|fbclid|gclid|ttclid|msclkid)/.test(k))u.searchParams.set(k,v);a.href=u.href});})();















































































































































(()=>{const form=document.querySelector('#abn-form'),sticky=document.querySelector('.abn-sticky');function update(){if(sticky)sticky.hidden=!form||form.querySelector('button[type=submit]').getBoundingClientRect().bottom>parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--abn-header-height')||0)}document.querySelector('[data-abn-sticky]')?.addEventListener('click',async()=>{const button=form?.querySelector('button[type=submit]'),stickyButton=document.querySelector('[data-abn-sticky]');if(!button||button.disabled||stickyButton.dataset.pending)return;stickyButton.dataset.pending='true';try{const single=[...form.querySelectorAll('.kaching-bundles__bar')].find(b=>/^buy\s*1$/i.test(b.querySelector('.kaching-bundles__bar-title')?.textContent.trim()||''));if(single){const values=[...document.querySelectorAll('[data-abn-sticky-option]')].map(s=>s.value);if(!single.classList.contains('kaching-bundles__bar--selected'))single.querySelector('.kaching-bundles__bar-main').click();await new Promise(requestAnimationFrame);single.querySelectorAll('.kaching-bundles__bar-variant-select').forEach((s,i)=>{if(values[i]&&s.value!==values[i]){s.value=values[i];s.dispatchEvent(new Event('change',{bubbles:true}))}});await new Promise(requestAnimationFrame)}if(!button.disabled)form.requestSubmit(button)}finally{delete stickyButton.dataset.pending}});addEventListener('scroll',update,{passive:true});update();const vs=[...document.querySelectorAll('[data-abn-video]')],reduced=matchMedia('(prefers-reduced-motion: reduce)');const o=new IntersectionObserver(es=>es.forEach(({target:v,isIntersecting})=>{v.muted=v.dataset.abnSound!=='true';if(isIntersecting&&!reduced.matches&&v.dataset.abnPaused!=='true')v.play().catch(()=>v.controls=true);else v.pause()}));vs.forEach(v=>{v.muted=true;v.controls=reduced.matches;const b=document.createElement("button");b.type="button";b.className="abn-motion-control";b.textContent=reduced.matches?"Play animation":"Pause animation";b.addEventListener("click",()=>{if(v.paused){v.dataset.abnPaused="false";v.play().catch(()=>{v.controls=true});b.textContent="Pause animation"}else{v.dataset.abnPaused="true";v.pause();b.textContent="Play animation"}});v.addEventListener("play",()=>b.textContent="Pause animation");v.addEventListener("pause",()=>b.textContent="Play animation");v.insertAdjacentElement("afterend",b);v.addEventListener("click",()=>{if(!v.controls)b.click()});o.observe(v)});})();















































































































































document.querySelector('#abn-selectors')?.addEventListener('change',e=>{if(e.target.dataset.option==='0'){const cfg=JSON.parse(document.querySelector('#abn-config').textContent),url=cfg.colorImages[e.target.value],img=document.querySelector('#abn-main-image');if(url&&img)img.src=url}});















































































































































document.querySelectorAll('.abn-root .collapsible-toggle').forEach(b=>b.addEventListener('click',()=>{const panel=document.getElementById(b.getAttribute('aria-controls'));if(!panel)return;const open=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!open));panel.hidden=open}));







































































(()=>{let start=0;const main=document.querySelector('[data-abn-zoom]'),buttons=[...document.querySelectorAll('[data-abn-image]')];if(!main)return;main.addEventListener('touchstart',e=>start=e.changedTouches[0].clientX,{passive:true});main.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-start;if(Math.abs(delta)<45)return;const image=document.querySelector('#abn-main-image'),i=buttons.findIndex(b=>b.dataset.abnImage===image.src),j=(i+(delta<0?1:-1)+buttons.length)%buttons.length;buttons[j]?.click()},{passive:true})})();















































































































































document.querySelectorAll('.abn-root dialog').forEach(d=>{d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){d.close();document.documentElement.style.overflow=''}}});d.addEventListener('keydown',e=>{if(e.key!=='Tab')return;const a=[...d.querySelectorAll('button:not(:disabled),a[href],input,select')].filter(x=>x.getBoundingClientRect().width);if(!a.length)return;if(e.shiftKey&&document.activeElement===a[0]){a.at(-1).focus();e.preventDefault()}else if(!e.shiftKey&&document.activeElement===a.at(-1)){a[0].focus();e.preventDefault()}})});















































































































































document.querySelector('.abn-menu-button')?.addEventListener('click',e=>{const b=e.currentTarget,open=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!open));document.querySelector('#abn-header-links').classList.toggle('abn-menu-open',!open)});document.querySelector('[data-abn-size]')?.addEventListener('click',()=>{const c=JSON.parse(document.querySelector('#abn-config').textContent),z=document.querySelector('#abn-zoom');z.querySelector('img').src=c.images[16];z.showModal();document.documentElement.style.overflow='hidden'});















































































































































document.querySelector('[data-abn-more]')?.addEventListener('click',e=>{const hidden=[...document.querySelectorAll('.abn-source-review[hidden]')];hidden.slice(0,6).forEach(x=>x.hidden=false);if(hidden.length<=6)e.currentTarget.hidden=true});















































































































































document.querySelectorAll("[data-abn-image]").forEach((b,i)=>b.setAttribute("aria-pressed",String(i===0)));















































































































































(()=>{const messages=['TODAY’S SPECIAL OFFER — BUY 1, GET 1 FREE','FREE TRACKED SHIPPING','★★★★★ 62.000+ HAPPY CUSTOMERS'];let index=0;const text=document.querySelector('[data-abn-ann-message]');function move(step){index=(index+step+messages.length)%messages.length;if(text)text.textContent=index===0&&innerWidth<750?'BUY 1, GET 1 FREE':messages[index]}document.querySelector('[data-abn-ann-prev]')?.addEventListener('click',()=>move(-1));document.querySelector('[data-abn-ann-next]')?.addEventListener('click',()=>move(1));const search=document.querySelector('.abn-header-search');document.querySelector('[data-abn-search]')?.addEventListener('click',()=>{search.hidden=!search.hidden;if(!search.hidden)search.querySelector('input[type=search]').focus()});document.querySelector('[data-abn-menu-close]')?.addEventListener('click',()=>{document.querySelector('#abn-header-links')?.classList.remove('abn-menu-open');document.querySelector('.abn-menu-button')?.setAttribute('aria-expanded','false')});document.querySelector('#abn-tracking-form')?.addEventListener('submit',e=>{e.preventDefault();const value=document.querySelector('#abn-tracking-number').value.trim();if(value)window.open('https://t.17track.net/en#nums='+encodeURIComponent(value),'_blank','noopener,noreferrer')});const clocks=[...document.querySelectorAll('[data-abn-sale-end]')];function tick(){clocks.forEach(el=>{const raw=el.dataset.abnSaleEnd,end=el.dataset.abnDailyReset==='true'?(Math.floor((Date.now()-7*3600000)/86400000)+1)*86400000+7*3600000:/^\d+$/.test(raw)?Number(raw)*1000:Date.parse(raw),left=Math.floor((end-Date.now())/1000);if(!Number.isFinite(end)||left<=0){el.hidden=true;const label=el.closest('.annbar__inner,.abn-announcement-center')?.querySelector('[data-abn-sale-label]');if(Number.isFinite(end)&&label)label.textContent='SHOP THE OFFER';return}el.hidden=false;messages[1]='LIMITED OFFER ENDING SOON';el.querySelector('[data-abn-hours]').textContent=String(Math.floor(left/3600)).padStart(2,'0');el.querySelector('[data-abn-minutes]').textContent=String(Math.floor(left/60)%60).padStart(2,'0');el.querySelector('[data-abn-seconds]').textContent=String(left%60).padStart(2,'0');el.setAttribute('aria-label',(el.dataset.abnDailyReset==='true'?'Daily offer resets at ':'Offer ends ')+new Date(end).toUTCString());const label=el.closest('.annbar__inner,.abn-announcement-center')?.querySelector('[data-abn-sale-label]');if(label)label.textContent='SALE ENDS IN'})}tick();if(clocks.length)setInterval(tick,1000)})();















































































































































document.querySelector('.abn-menu-button')?.addEventListener('click',()=>{document.documentElement.style.overflow=document.querySelector('.abn-menu-button').getAttribute('aria-expanded')==='true'?'hidden':''});document.querySelector('[data-abn-menu-close]')?.addEventListener('click',()=>{document.documentElement.style.overflow='';document.querySelector('.abn-menu-button')?.focus()});document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;document.querySelector('#abn-header-links')?.classList.remove('abn-menu-open');document.querySelector('.abn-menu-button')?.setAttribute('aria-expanded','false');const s=document.querySelector('.abn-header-search');if(s)s.hidden=true;if(!document.querySelector('dialog[open]'))document.documentElement.style.overflow=''});















































































































































(()=>{const p=document.querySelector('#progressBar');if(p){const update=()=>{const height=document.documentElement.scrollHeight-innerHeight;p.style.width=(height>0?Math.min(100,Math.max(0,scrollY/height*100)):0)+'%'};addEventListener('scroll',update,{passive:true});addEventListener('resize',update);update()}const nav=document.querySelector('.abn-nav');if(nav){const update=()=>document.documentElement.style.setProperty('--abn-header-height',nav.getBoundingClientRect().height+'px');new ResizeObserver(update).observe(nav);update()}})();















































































































































document.querySelector('[data-abn-review-jump]')?.addEventListener('click',()=>document.querySelector('.abn-source-reviews')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));document.querySelector('[data-abn-review-jump]')?.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();e.currentTarget.click()}});















































































































































(()=>{const root=document.querySelector('.abn-modern-reviews');if(!root)return;const container=root.querySelector('.jdgm-masonry-grid__container'),items=[...container.querySelectorAll('.jdgm-masonry-grid__masonry-item')],sort=root.querySelector('.jm-sort-filter__select'),rating=root.querySelector('[data-abn-review-rating]'),panel=root.querySelector('.abn-review-filter-panel'),section=root.querySelector('.jdgm-masonry-grid'),more=root.querySelector('.jdgm-masonry-grid__btn');let expanded=false,changed=false;const score=i=>Number(i.querySelector('[data-abn-review-score]').dataset.abnReviewScore),date=i=>Date.parse(i.querySelector('[data-abn-review-date]').dataset.abnReviewDate)||0;function apply(){const filter=Number(rating.value),value=sort.value;const rows=[...items];if(changed){if(value==='lowest_rating')rows.sort((a,b)=>score(a)-score(b));else if(value==='highest_rating')rows.sort((a,b)=>score(b)-score(a));else if(value==='created_at')rows.sort((a,b)=>date(b)-date(a));else if(value==='pictures_first'||value==='with_pictures')rows.sort((a,b)=>Number(!!b.querySelector('img:not(.jm-verified-by-shop-badge__image)'))-Number(!!a.querySelector('img:not(.jm-verified-by-shop-badge__image)')))}let shown=0;rows.forEach(item=>{container.append(item);let visible=(!filter||score(item)===filter)&&(value!=='with_pictures'||!!item.querySelector('img:not(.jm-verified-by-shop-badge__image)'));if(!changed&&!item.querySelector('[data-abn-modern-review]'))visible=false;item.hidden=!visible;if(visible)shown++});root.querySelector('.abn-review-empty').hidden=shown>0;section.style.maxHeight=expanded?'none':'550px';if(more){more.textContent=expanded?'Show less':'Show more';more.setAttribute('aria-expanded',String(expanded))}}sort?.addEventListener('change',()=>{changed=true;apply()});rating?.addEventListener('change',()=>{changed=true;apply()});more?.addEventListener('click',()=>{expanded=!expanded;apply()});root.querySelector('.jm-custom-answer-filter')?.addEventListener('click',e=>{panel.hidden=!panel.hidden;e.currentTarget.setAttribute('aria-expanded',String(!panel.hidden));if(!panel.hidden)rating.focus()});root.querySelector('[data-abn-review-filter-close]')?.addEventListener('click',()=>{panel.hidden=true;root.querySelector('.jm-custom-answer-filter')?.setAttribute('aria-expanded','false')});root.querySelector('[data-testid="write-review-button"]')?.addEventListener('click',()=>{const d=document.querySelector('#abn-review-form');d.showModal();document.documentElement.style.overflow='hidden'});root.querySelectorAll('.jm-media-grid__item').forEach(button=>button.addEventListener('click',()=>{const image=button.querySelector('img');if(!image)return;const d=document.querySelector('#abn-zoom');d.querySelector('img').src=image.src;d.showModal();document.documentElement.style.overflow='hidden'}));root.querySelectorAll('.jm-media-grid__arrow').forEach(button=>button.addEventListener('click',()=>{const grid=root.querySelector('.jm-media-grid__items')||root.querySelector('.jm-media-grid');if(grid)grid.scrollBy({left:button.className.includes('next')?150:-150,behavior:'smooth'})}));apply()})();































































































if(document.querySelector('#abn-form')){const b=document.querySelector('[data-abn-sticky]');if(b)b.textContent='Add to cart'}















































(()=>{const root=document.querySelector('native-carousel.text-with-icons');if(!root)return;const slides=[...root.querySelectorAll('native-carousel-item')],dots=[...root.querySelectorAll('page-dots button')],wide=matchMedia('(min-width:1000px)');let index=0,start=0;function show(n){index=(n+slides.length)%slides.length;slides.forEach((e,i)=>e.hidden=!wide.matches&&i!==index);dots.forEach((e,i)=>e.setAttribute('aria-current',String(i===index)))}dots.forEach((e,i)=>e.addEventListener('click',()=>show(i)));root.addEventListener('touchstart',e=>start=e.changedTouches[0].clientX,{passive:true});root.addEventListener('touchend',e=>{let d=e.changedTouches[0].clientX-start;if(Math.abs(d)>45&&!wide.matches)show(index+(d<0?1:-1))},{passive:true});wide.addEventListener('change',()=>show(index));show(0)})();





























(()=>{const form=document.querySelector('#abn-form');if(!form)return;const box=form.querySelector('#abn-kaching');if(!box)return;function update(){const active=!!box.querySelector('.kaching-bundles__block--loaded');form.classList.toggle('abn-has-kaching',active);const qty=form.querySelector('.abn-product-quantity');if(qty)qty.hidden=active;const sticky=document.querySelector('[data-abn-sticky]');if(sticky)sticky.textContent='Add to cart'}new MutationObserver(update).observe(box,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});update()})();








(()=>{const form=document.querySelector('#abn-form'),sticky=document.querySelector('.abn-sticky');if(!form||!sticky)return;const cfg=JSON.parse(document.querySelector('#abn-config').textContent);function targets(){const bar=form.querySelector('.kaching-bundles__bar--selected');return bar?[...bar.querySelectorAll('.kaching-bundles__bar-variant-select')].slice(0,2):[...form.querySelectorAll('#abn-selectors select[data-option]')]}function sync(){const source=targets();sticky.querySelectorAll('[data-abn-sticky-option]').forEach((e,i)=>{if(source[i])e.value=source[i].value});const color=source[0]?.value,img=sticky.querySelector('.abn-sticky-image');if(color&&cfg.colorImages[color])img.src=cfg.colorImages[color];const price=form.querySelector('.kaching-bundles__bar .kaching-bundles__bar-price');if(price)sticky.querySelector('[data-abn-sticky-price]').textContent=price.textContent.trim()}sticky.addEventListener('change',e=>{const index=e.target.dataset.abnStickyOption;if(index===undefined)return;const target=targets()[Number(index)];if(target){target.value=e.target.value;target.dispatchEvent(new Event('change',{bubbles:true}));setTimeout(sync,0)}});form.addEventListener('change',()=>setTimeout(sync,0));new MutationObserver(sync).observe(form.querySelector('#abn-kaching'),{childList:true,subtree:true,attributes:true,attributeFilter:['class']});sync()})();



(()=>{document.querySelectorAll('[data-abn-video]').forEach(v=>{const wrapper=v.closest('.video-wrapperrrr');if(!wrapper)return;const old=wrapper.querySelector('.play-button'),button=document.createElement('button');button.type='button';button.className='abn-video-sound';button.textContent='Play with sound';button.setAttribute('aria-label','Play video with sound');if(old)old.replaceWith(button);else wrapper.append(button);const toggle=document.createElement('button');toggle.type='button';toggle.className='abn-video-audio-toggle';toggle.textContent='Sound off';toggle.setAttribute('aria-label','Turn on video sound');toggle.setAttribute('aria-pressed','false');wrapper.append(toggle);function sound(on){v.dataset.abnSound=String(on);v.muted=!on;if(on){v.removeAttribute('muted');v.volume=1;v.controls=true;v.dataset.abnPaused='false';v.play().catch(()=>{});button.hidden=true}toggle.textContent=on?'Sound on':'Sound off';toggle.setAttribute('aria-label',on?'Mute video':'Turn on video sound');toggle.setAttribute('aria-pressed',String(on))}button.addEventListener('click',()=>sound(true));toggle.addEventListener('click',()=>sound(v.muted));v.addEventListener('volumechange',()=>{toggle.textContent=v.muted?'Sound off':'Sound on';toggle.setAttribute('aria-pressed',String(!v.muted))})})})();

/* Bronoir offer presentation reads Kaching; checkout pricing stays app-owned. */
(()=>{const form=document.querySelector('#abn-form'),box=document.querySelector('#abn-kaching');if(!form||!box)return;let initialized=false,scheduled=false;
const set=(e,t)=>{if(e&&e.textContent!==t)e.textContent=t};
function sync(){scheduled=false;const bars=[...box.querySelectorAll('.kaching-bundles__bar')];if(!initialized){const bogo=bars.find(b=>/buy\s*1,?\s*get\s*1\s*free/i.test(b.textContent));if(!bogo||!box.querySelector('.kaching-bundles__block--loaded'))return;initialized=true;if(!bogo.classList.contains('kaching-bundles__bar--selected'))bogo.querySelector('.kaching-bundles__bar-main').click()}
 const bar=box.querySelector('.kaching-bundles__bar--selected');if(!bar)return;const bogo=/buy\s*1,?\s*get\s*1\s*free/i.test(bar.textContent),label=bogo?'Buy 1, Get 1 Free · 2 pairs':'Buy 1 · 1 pair',price=bar.querySelector('.kaching-bundles__bar-price')?.textContent.trim(),compare=bar.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();set(document.querySelector('[data-abn-hero-offer]'),label);set(document.querySelector('[data-abn-sticky-offer]'),'Buy 1');if(price){set(document.querySelector('.abn-price strong'),price);set(document.querySelector('[data-abn-sticky-price]'),bars[0]?.querySelector('.kaching-bundles__bar-price')?.textContent.trim()||price)}if(compare)set(document.querySelector('.abn-price s'),compare);
 const parse=t=>Number((t||'').replace(/[^0-9.]/g,''));if(price&&compare){const saved=Math.round((parse(compare)-parse(price))*100);if(Number.isFinite(saved))set(document.querySelector('.abn-price span'),'Save '+new Intl.NumberFormat('en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(saved/100))}}
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(sync)}}new MutationObserver(schedule).observe(box,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});form.addEventListener('change',schedule);schedule();
 const sticky=document.querySelector('.abn-sticky');if(sticky)new ResizeObserver(()=>document.documentElement.style.setProperty('--abn-sticky-space',Math.ceil(sticky.getBoundingClientRect().height+24)+'px')).observe(sticky);
})();

(()=>{const e=document.querySelector('[data-abn-sticky-offer]');if(e)e.textContent='Buy 1'})();

(()=>{const gallery=document.querySelector('.abn-gallery'),image=document.querySelector('#abn-main-image');if(!gallery||!image)return;const thumbs=[...gallery.querySelectorAll('[data-abn-image]')],strip=gallery.querySelector('.abn-thumbs'),stage=gallery.querySelector('.abn-gallery-stage'),counter=gallery.querySelector('.abn-gallery-counter');if(!thumbs.length)return;
function current(){return Math.max(0,thumbs.findIndex(t=>t.dataset.abnImage===image.getAttribute('src')))}function show(index){index=(index+thumbs.length)%thumbs.length;image.src=thumbs[index].dataset.abnImage;image.alt='AERA Bronoir Skin Pro — image '+(index+1)+' of '+thumbs.length;thumbs.forEach((t,i)=>{t.setAttribute('aria-pressed',String(i===index));t.setAttribute('aria-label','Show product image '+(i+1))});counter.textContent=(index+1)+' / '+thumbs.length;const target=thumbs[index];strip.scrollTo({left:Math.max(0,target.offsetLeft-strip.offsetLeft-(strip.clientWidth-target.offsetWidth)/2),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
gallery.addEventListener('click',e=>{const arrow=e.target.closest('[data-abn-gallery-step]'),thumb=e.target.closest('[data-abn-image]');if(arrow)show(current()+Number(arrow.dataset.abnGalleryStep));else if(thumb)show(thumbs.indexOf(thumb))});stage.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(current()+(e.key==='ArrowRight'?1:-1))}});
let start=null,suppressClick=false;const zoom=stage.querySelector('[data-abn-zoom]');zoom.addEventListener('pointerdown',e=>{if(e.isPrimary)start={x:e.clientX,y:e.clientY}});zoom.addEventListener('pointercancel',()=>start=null);zoom.addEventListener('pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.3){suppressClick=true;show(current()+(dx<0?1:-1));setTimeout(()=>suppressClick=false,400)}});zoom.addEventListener('click',e=>{if(suppressClick){e.preventDefault();e.stopImmediatePropagation();suppressClick=false}},true);show(current());})();
